var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.876 5.99228C14.424 6.06078 14.9238 5.67205 14.9923 5.12403C15.0608 4.57601 14.6721 4.07622 14.124 4.00772L13.876 5.99228ZM5.11043 14.0061C4.56152 13.9451 4.06711 14.3407 4.00612 14.8896C3.94513 15.4385 4.34066 15.9329 4.88957 15.9939L5.11043 14.0061ZM11.1918 15.688L11.0814 16.6819L11.1918 15.688ZM14.124 4.00772L9.18145 3.3899L8.93338 5.37445L13.876 5.99228L14.124 4.00772ZM11.3023 14.6941L5.11043 14.0061L4.88957 15.9939L11.0814 16.6819L11.3023 14.6941ZM8.28538 10.7758L11.7044 11.178L11.9381 9.1917L8.51907 8.78946L8.28538 10.7758ZM13.2599 13.0956C13.1702 14.0827 12.2873 14.8035 11.3023 14.6941L11.0814 16.6819C13.1798 16.915 15.0605 15.3794 15.2517 13.2767L13.2599 13.0956ZM15.2517 13.2767C15.4367 11.2421 13.9671 9.43041 11.9381 9.1917L11.7044 11.178C12.6569 11.2901 13.3467 12.1405 13.2599 13.0956L15.2517 13.2767ZM5 7.08121C5 8.96759 6.41192 10.5554 8.28538 10.7758L8.51907 8.78946C7.65283 8.68755 7 7.95342 7 7.08121H5ZM9.18145 3.3899C6.96114 3.11236 5 4.84361 5 7.08121H7C7 6.04661 7.90677 5.24613 8.93338 5.37445L9.18145 3.3899Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2L9 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.47e325e83609b9f07ee8abd3b0c68216.svg";
export { ForwardRef as ReactComponent };